import * as React from 'react';

const DEFAULT_MAX_LENGTH = 22;
const ELLIPSIS = '...';

export function useMiddleTruncate(maxLength: number = DEFAULT_MAX_LENGTH) {
  return React.useCallback(
    (value?: string) => {
      if (!value) return '';
      if (maxLength <= 0) return '';
      if (value.length <= maxLength) return value;

      const remaining = maxLength - ELLIPSIS.length;
      if (remaining < 2) return value.slice(0, maxLength);

      const head = Math.ceil(remaining / 2);
      const tail = Math.floor(remaining / 2);
      return `${value.slice(0, head)}${ELLIPSIS}${value.slice(-tail)}`;
    },
    [maxLength]
  );
}
